export const PUBLIC_URLS = [
  "contest-participants/verify-mobile/",
  "contest-participants/verify-mobile/otp/",
];
